$(function () {
    $('.related-areas-block').each(
        (i, element) => i % 2 === 0 && element.classList.add('bg-light')
    );
});
